import Page from 'component/Page';
import { useEffect, useMemo, useState } from 'react';
import * as fincode1 from 'util/requestFincode';
import { sendPost } from 'util/request';
import string from 'util/string';
import Urls from 'util/urls';
import Table from 'component/Table';
import { useSelector } from 'react-redux';
import { selectCurrentUser } from 'redux/user/user.selector';
import { ACCOUNT_ROLE_ADMIN } from 'util/permission';
import { useCallback } from 'react';
import { initFincode, getCardToken, registerCard, executePayment, FincodeInstance, FincodeUI } from "@fincode/js"
import { getParams, GUIDChecker, nNU, showToast, formatDate, formatDateAndTime, calculateExpirationTime } from 'util/utils';
import { Button } from 'react-bootstrap';
const headers = [
    string.APP_SC_ASSIGN_ID_USERNAME,
    string.APP_SC_ASSIGN_ID_DISPLAY_NAME,
    string.APP_SC_ASSIGN_ID_POC_ID,
];

const PurchaseAppId = ({ data = { id: null } }) => {
    //-------------------------------HOOKS-------------------------------------------------------------
    const params = getParams();
    //const fincode = createFincode({ apiKey: "m_test_M2RmOWQ5NGEtNDMwYy00YmIyLWFiY2UtYTU5MzhmN2UxMTM2MDhhMjYyMDMtNjNjNi00NjdmLTg4YzktZGYzZjI4MjZkNDg1c18yNDAyMjcwNjIwMw", isLiveMode: true })
    const serviceCodeId = data.id || params?.id;
    const currentUser = useSelector(selectCurrentUser);
    const isAdmin = useMemo(
        () => currentUser.accountRole === ACCOUNT_ROLE_ADMIN,
        [ currentUser.accountRole ]
    );
    const isMonitorOnly = useMemo(
        () => currentUser.isMonitorOnly === 1,
        [ currentUser.isMonitorOnly ]
    );
    const [ page, setPage ] = useState(1);
    const [ total, setTotal ] = useState(0);
    const [ pageSize, setPageSize ] = useState(100);
    const [ searchId, setSearchId ] = useState('');
    const [ debouncedSearchId, setDebouncedSearchId ] = useState(searchId);
    const [ users, setUsers ] = useState([]);
    const [ assignUsers, setAssignUsers ] = useState([]);
    const [ assignTotal, setAssignTotal ] = useState(0);
    const [ assign, setAssign ] = useState(null);
    const [ serviceCode, setServiceCode ] = useState(null);
    const [ assignableVolume, setAssignableVolume ] = useState(0);
    const [ selectedItem, setSelectedItem ] = useState([]);
    const [ selectedCheckboxCount, setSelectedCheckboxCount ] = useState(0);
    const [ price, setPrice ] = useState(800);
    const [ isAnyCheckboxSelected, setIsAnyCheckboxSelected ] = useState(false);
    const [ token, setToken ] = useState(null)
    //------------------------------FUNCTIONS----------------------------------------------------------
    const doSearch = useCallback(
        async (page, pageSize, searchKeyword, getAll = false) => {
            if (!nNU(currentUser.id)) {
                return;
            }
            let data = await sendPost({
                url: Urls.pocaccount.userlist,
                body: {
                    id: currentUser.id,
                    offset: (page - 1) * pageSize,
                    size: pageSize,
                    keyword: searchKeyword,
                },
            });
            const { total, result } = data;
            if (!getAll) {
                setUsers(result);
                setTotal(total);
            }
            return result;
        },
        [ currentUser ]
    );

    useEffect(() => {
        const timerId = setTimeout(() => {
            setDebouncedSearchId(searchId);
        }, 500);

        return () => {
            clearTimeout(timerId);
        };
    }, [ searchId ]);

    useEffect(() => {
        doSearch(page, pageSize, debouncedSearchId);
    }, [ page, pageSize, debouncedSearchId, doSearch ]);

    const dataTable = useCallback(
        (data) => data.map((raw, key) => ({
            key: raw.id,
            data: [
                raw?.username,
                raw?.displayName,
                raw?.pocId.toString().padStart(6, '0'),
            ],
            raw,
        })),
        []
    );
    const dataSubtable = useCallback(
        () => {
            let data = [];
            data.push({
                data: [
                    selectedCheckboxCount,
                    price,
                    selectedCheckboxCount * 800
                ]
            });
            // console.log(data)
            return data;
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [ selectedCheckboxCount, price, isAnyCheckboxSelected ]
    );

    const handlePayClick = async () => {
        try {
            const fincode = await initFincode({
                publicKey: "p_test_ZmVkNGFjODgtNzRmNC00NGEzLWFlNzAtY2FjZTRiMTBmOGI4ZjBjY2RiNjItMzczNS00MzA5LWJiMGEtODBmZWM2M2RhMmNlc18yNDAyMjcwNjIwMw", // Public key
                isLiveMode: true, // fincode Environment
            });

            const ui = fincode.ui({ layout: "vertical" });
            ui.create("payment", { layout: "vertical" });
            ui.mount("fincode", "400");

            const res = await getCardToken({
                fincode: fincode, // fincode instance (FincodeInstance)
                ui: ui, // fincode UI instance (FincodeUI). : you can use the data input in the fincode ui component directly.
                number: "1" // how many tokens you want to get (string, default: "1")
            })
            const tokens = res // there are 4 tokens in this array.
            setToken(tokens)
        } catch (error) {
            console.error('Error:', error);
        }
        let data = {
            "pay_type": "Card",
            "default_flag": "1",
            "client_field_1": "string",
            "client_field_2": "string",
            "client_field_3": "string",
            "card": {
                "token": token,
            }
        };
        const response = await fincode1.sendPost({
            url: 'https://api.test.fincode.jp/v1/customers/{customer_id}/payment_methods',
            body: data,
        })
    };

    // console.log(selectedCheckboxCount)
    useEffect(() => {
        const newPrice = selectedCheckboxCount * 800;
        setPrice(newPrice);
    }, [ selectedCheckboxCount ]);
    const onSelect = (e) => {
        let { raw } = e;
        let arr;
        let idx = -1;
        selectedItem?.forEach((item, index) => {
            if (item.pocId === raw.pocId) {
                idx = index;
                return;
            }
        });
        if (idx > -1) {
            let { [ idx ]: itm, ...rest } = selectedItem;
            arr = Object.values(rest);
        } else {
            arr = [ ...selectedItem, raw ];
        }
        setSelectedItem(arr);
        setSelectedCheckboxCount(arr.length);
        setIsAnyCheckboxSelected(arr.length > 0);
    };

    const actions = (isMonitorOnly === false) ? [
        ({ raw }) => {
            if (raw.status !== 1) {
                return;
            }
            let idx = -1;
            selectedItem?.forEach((item, index) => {
                if (item.pocId === raw.pocId) {
                    idx = index;
                    return;
                }
            });
            return selectedItem.indexOf(raw.pocId) > -1
                ? null
                : {
                    render: idx > -1 ? 'selected' : 'select',
                    onClick: onSelect,
                };
        },
    ] : [];

    // const mainActions = (assignableVolume > 0) ? [
    //     {
    //         icon: 'assign', title: string.APP_SC_ASSIGN_ID, onClick: () => {
    //             if (assignUsers.length > 0) {
    //                 setAssign(assignUsers);
    //             }
    //         }
    //     },
    // ] : [];
     const mainActions = [
        {        
			icon: 'pay',
			title: string.APP_PC_PREPAID_PAY,
			onClick: () => handlePayClick(),
		
        }

    ];

    //-------------------------------RETURN------------------------------------------------------------
    return (
        <>
            <Page
                // title={`合計：${assignableVolume}、割当：${assignTotal}／残り：${assignableVolume - assignTotal}`}
                body={
                    <>
                        <Table
                            className="nowrap"
                            page={page}
                            pageSize={pageSize}
                            total={total}
                            onPageChanged={setPage}
                            onPageSizeChanged={setPageSize}
                            headers={headers}
                            data={dataTable(users)}
                            isPaging={false}
                            mainActions={mainActions}
                            actions={actions}
                            search={false}
                        />
                        {isAnyCheckboxSelected && (
                            <Table
                                isPaging={false}
                                headers={[
                                    'appid',
                                    'prices',
                                    'quantity',
                                ]}
                                data={dataSubtable()}
                            />
                        )}
                        {/* <div className='function-button-area' style={{ marginTop: '15px' }}>
                            <Button className="btn" onClick={handlePayClick} >
                                PAY
                            </Button>
                        </div> */}
                    </>
                }
            />
        </>
    );
};

export default PurchaseAppId;
